<template>
	<div>
		<div id="quest" class="container is-fluid">
			<div id="app">
				<component ref="inputs" v-for="n in 300" :is="randomComp()"></component>
			</div>
		</div>
		<footer class="footer">
			<div id="biteme" class="container">
				<button class="topcoat-button--large--cta"
				        @click="validateAllInputs">{{bite()}}</button>
			</div>
		</footer>
	</div>
</template>

<script>
	import _ from 'lodash'
	import swal from 'sweetalert2'
	import 'sweetalert2/dist/sweetalert2.css'
	import 'assets/css/topcoat-desktop-light.css'
	import Switcher from './components/Switcher.vue'
	import Radio from './components/Radio.vue'
	import Range from './components/Range.vue'
	import Checkbox from './components/Checkbox.vue'
	import TextBlock from './components/TextBlock.vue'
	import TextInput from './components/TextInput.vue'
	import Selection from './components/Selection.vue'
	import randWords from 'random-sentence'

	//	const comps = ['TextBlock', 'TextInput', 'Selection', 'Radio', 'Switcher']
	const comps = ['TextBlock', 'Selection', 'Radio', 'Range', 'Checkbox', 'TextInput', 'Switcher']
	let texBlockCnt=0;
	export default {
		name: 'app',
		components: {
			Radio,
			Range,
			Switcher,
			Checkbox,
			TextBlock,
			TextInput,
			Selection
		},
		methods: {
			bite(){
				return randWords({min: 1, max: 2});
			},
			randomComp(){
				let arr = comps
				if (texBlockCnt > 1) {
					arr = comps.filter(function (item) {
						return item !== 'TextBlock'
					});
				}

				let result = _.sample(arr)
				if (result==="TextBlock") texBlockCnt++
				return result
			},
			validateAllInputs() {
				let validatings = this.$refs.inputs.map(function (input) {
					return input.$validator.validateAll()
				})
				Promise.all(validatings).then(() => {
					swal({
						title: randWords({min: 4, max: 8}),
						text: randWords({min: 2, max: 4}),
						type: randWords({min: 1, max: 2}),
						showCancelButton: true,
						confirmButtonText: randWords({min: 1, max: 5}),
						confirmButtonColor: '#00d1b2',
						cancelButtonText: randWords({min: 1, max: 5}),
						cancelButtonColor: '#ffdd57'
					}).then(function () {
						window.location.reload(true);
					}, function (dismiss) {
						// dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
						if (dismiss === 'cancel') {
							swal.close()
						}
					})
				}).catch((err) => {
					swal({
						title: randWords({min: 1, max: 2}),
						text: randWords({min: 4, max: 8}),
						type: 'error',
						showCloseButton: true,
						confirmButtonText: randWords({min: 1, max: 5}),
						confirmButtonColor: '#ff3860'
					}).then(function () {
						window.location.reload(true);
					}, function (dismiss) {
						// dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
//						if (dismiss === 'close') {
//							swal.close()
//						}
					})
				})
			},
			cleanAllErrors(){
				this.$refs.inputs.forEach(input => {
					input.errors.clear()
				})
			}
		}
	}
</script>
<style>
	#app {
		/*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
		/*-webkit-font-smoothing: antialiased;*/
		/*-moz-osx-font-smoothing: grayscale;*/
		/*text-align: center;*/
		/*color: #2c3e50;*/
		margin-top: 60px;
	}

	#app > div {
		display: inline-block;
		margin: 5px;
		/*float: left;*/
	}

	.footer {
		position: fixed !important;
		background-color: #4a4a4a !important;
		z-index: 1000;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 1.5rem !important;

	}

	#quest {
		margin-bottom: 160px;
	}

	#biteme {
		text-align: center;
	}

	.swal2-modal .swal2-spacer {
		height: 1px !important;
		color: transparent;
		border: 0;
	}

	.help {
		color: red;
	}
</style>



// WEBPACK FOOTER //
// App.vue?788e52ca